module.exports = __webpack_public_path__ + "static-portal/img/3.775ff4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/3.jpg
// module id = h7J6
// module chunks = 4